{
  "awaleScreen": {
    "header": {
      "title": "🎯 Awalé",
      "loading": "Chargement Awalé…"
    },
    "tabs": {
      "mine": "Mes Sessions",
      "explore": "Explorer",
      "classement": "Classement"
    },
    "mySessions": {
      "title": "Mes Sessions",
      "emptyTitle": "Vous n'avez rejoint aucune session.",
      "emptyHint": "Explorez les sessions disponibles !",
      "enter": "Entrer →",
      "runLabel": "Run {{number}} — {{title}}",
      "turnTime": "{{seconds}}s/tour"
    },
    "explore": {
      "title": "Sessions Disponibles",
      "emptyTitle": "Aucune session disponible.",
      "emptyHint": "Vous avez peut-être déjà rejoint toutes les sessions.",
      "participateFree": "Participer gratuitement",
      "participatePaid": "Participer ({{price}} CFA)"
    },
    "session": {
      "backToSessions": "Retour aux sessions",
      "noRunAvailable": "Aucun run disponible pour cette session."
    },
    "run": {
      "matchFinishedTitle": "Match Terminé",
      "matchFinishedSub": "Ce run est officiellement clôturé.\nConsultez le classement pour voir les gagnants.",
      "waitingForLaunch": "En attente de lancement par l'administrateur",
      "runInProgress": "Run en cours",
      "notInRun": "Vous n'êtes pas dans ce run",
      "playNow": "Jouer maintenant",
      "info": {
        "run": "Run",
        "prep": "Prép.",
        "turn": "Tour",
        "launched": "Lancé"
      }
    },
    "match": {
      "yourMatch": "Votre match",
      "you": "Vous",
      "opponent": "Adversaire",
      "victory": "🏆 Victoire !",
      "defeat": "❌ Défaite",
      "resultPending": "Résultat en attente"
    },
    "status": {
      "created": "⏳ En attente",
      "launched": "🔵 En cours",
      "finished": "🟢 Terminé"
    },
    "classement": {
      "title": "Classement",
      "emptyTitle": "Vous n'êtes inscrit à aucune session.",
      "backToClassement": "Retour",
      "runsCount_one": "{{count}} run",
      "runsCount_other": "{{count}} runs",
      "matchesCount": "{{finished}}/{{total}} matchs",
      "noRunAvailable": "Aucun run disponible.",
      "noMatchInRun": "Aucun match dans ce run",
      "matchLabel": "Match {{number}}",
      "matchDone": "✅ Terminé",
      "matchLive": "🔵 En cours",
      "winnerLabel": "Gagnant · {{name}}"
    },
    "errors": {
      "joinSession": "Erreur joinSession",
      "loadRun": "Erreur chargement run",
      "sessionExpired": "Session expirée — reconnectez-vous"
    }
  },
  "damesScreen": {
    "header": {
      "title": "♟️ Dames",
      "loading": "Chargement Dames…"
    },
    "tabs": {
      "mine": "Mes Sessions",
      "explore": "Explorer",
      "classement": "Classement"
    },
    "mySessions": {
      "title": "Mes Sessions",
      "emptyTitle": "Vous n'avez rejoint aucune session.",
      "emptyHint": "Explorez les sessions disponibles !",
      "enter": "Entrer →",
      "runLabel": "Run {{number}} — {{title}}",
      "turnTime": "{{seconds}}s/tour"
    },
    "explore": {
      "title": "Sessions Disponibles",
      "emptyTitle": "Aucune session disponible.",
      "emptyHint": "Vous avez peut-être déjà rejoint toutes les sessions.",
      "participateFree": "Participer gratuitement",
      "participatePaid": "Participer ({{price}} CFA)"
    },
    "session": {
      "backToSessions": "Retour aux sessions",
      "noRunAvailable": "Aucun run disponible pour cette session."
    },
    "run": {
      "matchFinishedTitle": "Match Terminé",
      "matchFinishedSub": "Ce run est officiellement clôturé.\nConsultez le classement pour voir les gagnants.",
      "waitingForLaunch": "En attente de lancement par l'administrateur",
      "runInProgress": "Run en cours",
      "notInRun": "Vous n'êtes pas dans ce run",
      "playNow": "Jouer maintenant",
      "info": {
        "run": "Run",
        "prep": "Prép.",
        "turn": "Tour",
        "launched": "Lancé"
      }
    },
    "match": {
      "yourMatch": "Votre match",
      "you": "Vous",
      "opponent": "Adversaire",
      "victory": "🏆 Victoire !",
      "defeat": "❌ Défaite",
      "resultPending": "Résultat en attente"
    },
    "status": {
      "created": "⏳ En attente",
      "launched": "🔵 En cours",
      "finished": "🟢 Terminé"
    },
    "classement": {
      "title": "Classement",
      "emptyTitle": "Vous n'êtes inscrit à aucune session.",
      "backToClassement": "Retour",
      "runsCount_one": "{{count}} run",
      "runsCount_other": "{{count}} runs",
      "matchesCount": "{{finished}}/{{total}} matchs",
      "noRunAvailable": "Aucun run disponible.",
      "noMatchInRun": "Aucun match dans ce run",
      "matchLabel": "Match {{number}}",
      "matchDone": "✅ Terminé",
      "matchLive": "🔵 En cours",
      "winnerLabel": "Gagnant · {{name}}"
    },
    "errors": {
      "joinSession": "Erreur joinSession",
      "loadRun": "Erreur chargement run",
      "sessionExpired": "Session expirée — reconnectez-vous"
    }
  },
  "tabAwale": {
    "connecting": "Connexion au serveur…",
    "loadingMatch": "Chargement de la partie…",
    "back": "Retour",
    "connectionError": "Impossible de se connecter au serveur",
    "prep": {
      "title": "Préparation",
      "subtitle": "La partie commence dans",
      "unit": "secondes",
      "hint": "L'adversaire peut vous rejoindre à tout moment"
    },
    "tiebreaker": {
      "banner": "🔥 Égalité — Premier à 12 gagne !",
      "small": "🔥 Manche décisive — Premier à 12",
      "badge": "🔥 Manche décisive"
    },
    "gameOver": {
      "victory": "Victoire !",
      "defeat": "Défaite",
      "reasonTimeout": "Temps écoulé",
      "reasonScore": "Score atteint",
      "reasonEmpty": "Plateau vide",
      "you": "Vous",
      "opponent": "Adversaire",
      "done": "Terminer"
    },
    "yourTurn": "🟢 Votre tour",
    "opponentTurn": "⏳ Tour adverse",
    "moveNumber": "Coup #{{number}}",
    "reconnecting": "⚠ Reconnexion…"
  },
  "tabDames": {
    "connecting": "Connexion au serveur…",
    "loadingMatch": "Chargement de la partie…",
    "back": "Retour",
    "connectionError": "Impossible de se connecter au serveur",
    "prep": {
      "title": "Préparation",
      "subtitle": "La partie commence dans",
      "unit": "secondes",
      "hint": "Rouge joue en premier"
    },
    "suddenDeath": {
      "banner": "⚡ Sudden Death — Premier à {{target}} captures gagne !",
      "small": "⚡ Sudden Death — {{current}}/{{target}} captures",
      "badge": "⚡ Sudden Death"
    },
    "gameOver": {
      "victory": "Victoire !",
      "defeat": "Défaite",
      "reasonTimeout": "Temps écoulé",
      "reasonNoPieces": "Plus de pièces",
      "reasonNoMoves": "Aucun mouvement possible",
      "reasonSuddenDeath": "{{target}} captures atteintes",
      "youPlay": "Vous jouez les {{color}}",
      "colorRed": "Rouges",
      "colorBlack": "Noirs",
      "captures": "Captures",
      "done": "Terminer",
      "opponent": "Adversaire"
    },
    "yourTurn": "🟢 Votre tour",
    "opponentTurn": "⏳ Tour adverse",
    "chainCapture": "🔗 Capture en chaîne !",
    "youAre": "Vous êtes les {{color}} ↓",
    "moveCount": "Coup #{{number}}",
    "reconnecting": "⚠ Reconnexion…",
    "movesAvailable_one": "{{count}} mouvement possible",
    "movesAvailable_other": "{{count}} mouvements possibles",
    "noMoveAvailable": "Aucun mouvement possible",
    "capturesShort": "cap."
  },
  "performanceScreen": {
    "header": {
      "title": "🎭 Performance",
      "subtitle": "Concours de performance"
    },
    "tabs": {
      "sessions": "Sessions",
      "explore": "Explorer",
      "submit": "Soumettre",
      "classement": "Classement"
    },
    "empty": {
      "noSessionJoined": "Aucune session rejointe",
      "exploreHint": "Explorez les concours disponibles",
      "noActiveRun": "Aucun run actif pour cette session",
      "noContestAvailable": "Aucun concours disponible",
      "comeBackLater": "Revenez plus tard",
      "noSubmissionOpenRun": "Aucun run ouvert aux soumissions",
      "waitAdminHint": "Attendez que l'administrateur ouvre les soumissions",
      "noResultAvailable": "Aucun résultat disponible",
      "resultsAppearHint": "Le classement apparaît quand les votes sont ouverts"
    },
    "noActiveRunBadge": "Aucun run actif",
    "back": "Retour",
    "notEnrolled": "Vous n'êtes pas encore inscrit à ce run",
    "submitVideosButton_one": "Soumettre {{count}} vidéo",
    "submitVideosButton_other": "Soumettre {{count}} vidéos",
    "completeSubmissions": "Compléter mes soumissions ({{current}}/{{max}})",
    "mySubmissions": "Mes soumissions ({{current}}/{{max}})",
    "participateFree": "Participer — Gratuit",
    "participatePaid": "Participer — {{price}} CFA",
    "videosToSubmit_one": "{{count}} vidéo à soumettre",
    "videosToSubmit_other": "{{count}} vidéos à soumettre",
    "videosRequired_one": "{{count}} vidéo requise",
    "videosRequired_other": "{{count}} vidéos requises",
    "chooseRun": "Choisir un run",
    "chooseAnotherRun": "Choisir un autre run",
    "videosProgress_one": "{{count}} vidéo",
    "videosProgress_other": "{{count}} vidéos",
    "readyToSend": "✓ Prêt à envoyer",
    "missingVideos_one": "{{count}} manquante",
    "missingVideos_other": "{{count}} manquantes",
    "ruleExact": "Ce run requiert exactement",
    "ruleAllSlots": "Tous les slots doivent être remplis avant l'envoi.",
    "sendVideos_one": "Envoyer {{count}} vidéo",
    "sendVideos_other": "Envoyer {{count}} vidéos",
    "fillAllSlots": "Remplissez tous les slots ({{ready}}/{{total}})",
    "successTitle": "✅ Soumission complète",
    "successMessage_one": "Votre vidéo a été soumise avec succès !",
    "successMessage_other": "Vos {{count}} vidéos ont été soumises avec succès !",
    "status": {
      "draft": "📝 Brouillon",
      "submissionsOpen": "🎥 Soumissions ouvertes",
      "votingOpen": "🗳️ Votes ouverts",
      "finished": "🏆 Terminé"
    },
    "slot": {
      "videoLabel": "Vidéo {{number}}",
      "alreadySubmitted": "Déjà soumise",
      "required": "Requis",
      "tapToChoose": "Appuyer pour choisir",
      "tapToChange": "Appuyer pour changer",
      "formats": "MP4 · MOV · WEBM",
      "descriptionPlaceholder": "Description (optionnel)…"
    },
    "uploadSteps": {
      "preparing": "Vidéo {{current}}/{{total}} — Préparation…",
      "sending": "Vidéo {{current}}/{{total}} — Envoi…",
      "saving": "Vidéo {{current}}/{{total}} — Enregistrement…",
      "uploadFailed": "Upload vidéo {{number}} échoué ({{status}})"
    },
    "permission": {
      "title": "Permission requise",
      "message": "Autorisez l'accès à votre galerie."
    }
  },
  "musicScreen": {
    "header": {
      "title": "🎵 Music",
      "subtitle": "Concours de music"
    },
    "tabs": {
      "sessions": "Sessions",
      "explore": "Explorer",
      "submit": "Soumettre",
      "classement": "Classement"
    },
    "empty": {
      "noSessionJoined": "Aucune session rejointe",
      "exploreHint": "Explorez les concours disponibles",
      "noActiveRun": "Aucun run actif pour cette session",
      "noContestAvailable": "Aucun concours disponible",
      "comeBackLater": "Revenez plus tard",
      "noSubmissionOpenRun": "Aucun run ouvert aux soumissions",
      "waitAdminHint": "Attendez que l'administrateur ouvre les soumissions",
      "noResultAvailable": "Aucun résultat disponible",
      "resultsAppearHint": "Le classement apparaît quand les votes sont ouverts"
    },
    "noActiveRunBadge": "Aucun run actif",
    "back": "Retour",
    "notEnrolled": "Vous n'êtes pas encore inscrit à ce run",
    "submitVideosButton_one": "Soumettre {{count}} vidéo",
    "submitVideosButton_other": "Soumettre {{count}} vidéos",
    "completeSubmissions": "Compléter mes soumissions ({{current}}/{{max}})",
    "mySubmissions": "Mes soumissions ({{current}}/{{max}})",
    "participateFree": "Participer — Gratuit",
    "participatePaid": "Participer — {{price}} CFA",
    "videosToSubmit_one": "{{count}} vidéo à soumettre",
    "videosToSubmit_other": "{{count}} vidéos à soumettre",
    "videosRequired_one": "{{count}} vidéo requise",
    "videosRequired_other": "{{count}} vidéos requises",
    "chooseRun": "Choisir un run",
    "chooseAnotherRun": "Choisir un autre run",
    "videosProgress_one": "{{count}} vidéo",
    "videosProgress_other": "{{count}} vidéos",
    "readyToSend": "✓ Prêt à envoyer",
    "missingVideos_one": "{{count}} manquante",
    "missingVideos_other": "{{count}} manquantes",
    "ruleExact": "Ce run requiert exactement",
    "ruleAllSlots": "Tous les slots doivent être remplis avant l'envoi.",
    "sendVideos_one": "Envoyer {{count}} vidéo",
    "sendVideos_other": "Envoyer {{count}} vidéos",
    "fillAllSlots": "Remplissez tous les slots ({{ready}}/{{total}})",
    "successTitle": "✅ Soumission complète",
    "successMessage_one": "Votre vidéo a été soumise avec succès !",
    "successMessage_other": "Vos {{count}} vidéos ont été soumises avec succès !",
    "status": {
      "draft": "📝 Brouillon",
      "submissionsOpen": "🎥 Soumissions ouvertes",
      "votingOpen": "🗳️ Votes ouverts",
      "finished": "🏆 Terminé"
    },
    "slot": {
      "videoLabel": "Vidéo {{number}}",
      "alreadySubmitted": "Déjà soumise",
      "required": "Requis",
      "tapToChoose": "Appuyer pour choisir",
      "tapToChange": "Appuyer pour changer",
      "formats": "MP3 · WAV · M4A",
      "descriptionPlaceholder": "Description (optionnel)…"
    },
    "uploadSteps": {
      "preparing": "Audio {{current}}/{{total}} — Préparation…",
      "sending": "Audio {{current}}/{{total}} — Envoi…",
      "saving": "Audio {{current}}/{{total}} — Enregistrement…",
      "uploadFailed": "Upload audio {{number}} échoué ({{status}})"
    }
  },
  "artisanatScreen": {
    "header": {
      "title": "🪡 Artisanat",
      "subtitle": "Concours de artisanat"
    },
    "tabs": {
      "sessions": "Sessions",
      "explore": "Explorer",
      "submit": "Soumettre",
      "classement": "Classement"
    },
    "empty": {
      "noSessionJoined": "Aucune session rejointe",
      "exploreHint": "Explorez les concours disponibles",
      "noActiveRun": "Aucun run actif pour cette session",
      "noContestAvailable": "Aucun concours disponible",
      "comeBackLater": "Revenez plus tard",
      "noSubmissionOpenRun": "Aucun run ouvert aux soumissions",
      "waitAdminHint": "Attendez que l'administrateur ouvre les soumissions",
      "noResultAvailable": "Aucun résultat disponible",
      "resultsAppearHint": "Le classement apparaît quand les votes sont ouverts"
    },
    "noActiveRunBadge": "Aucun run actif",
    "back": "Retour",
    "notEnrolled": "Vous n'êtes pas encore inscrit à ce run",
    "submitVideosButton_one": "Soumettre {{count}} vidéo",
    "submitVideosButton_other": "Soumettre {{count}} vidéos",
    "completeSubmissions": "Compléter mes soumissions ({{current}}/{{max}})",
    "mySubmissions": "Mes soumissions ({{current}}/{{max}})",
    "participateFree": "Participer — Gratuit",
    "participatePaid": "Participer — {{price}} CFA",
    "videosToSubmit_one": "{{count}} vidéo à soumettre",
    "videosToSubmit_other": "{{count}} vidéos à soumettre",
    "videosRequired_one": "{{count}} vidéo requise",
    "videosRequired_other": "{{count}} vidéos requises",
    "chooseRun": "Choisir un run",
    "chooseAnotherRun": "Choisir un autre run",
    "videosProgress_one": "{{count}} vidéo",
    "videosProgress_other": "{{count}} vidéos",
    "readyToSend": "✓ Prêt à envoyer",
    "missingVideos_one": "{{count}} manquante",
    "missingVideos_other": "{{count}} manquantes",
    "ruleExact": "Ce run requiert exactement",
    "ruleAllSlots": "Tous les slots doivent être remplis avant l'envoi.",
    "sendVideos_one": "Envoyer {{count}} vidéo",
    "sendVideos_other": "Envoyer {{count}} vidéos",
    "fillAllSlots": "Remplissez tous les slots ({{ready}}/{{total}})",
    "successTitle": "✅ Soumission complète",
    "successMessage_one": "Votre vidéo a été soumise avec succès !",
    "successMessage_other": "Vos {{count}} vidéos ont été soumises avec succès !",
    "status": {
      "draft": "📝 Brouillon",
      "submissionsOpen": "🎥 Soumissions ouvertes",
      "votingOpen": "🗳️ Votes ouverts",
      "finished": "🏆 Terminé"
    },
    "slot": {
      "videoLabel": "Vidéo {{number}}",
      "alreadySubmitted": "Déjà soumise",
      "required": "Requis",
      "tapToChoose": "Appuyer pour choisir",
      "tapToChange": "Appuyer pour changer",
      "formats": "MP4 · MOV · WEBM",
      "descriptionPlaceholder": "Description (optionnel)…"
    },
    "uploadSteps": {
      "preparing": "Vidéo {{current}}/{{total}} — Préparation…",
      "sending": "Vidéo {{current}}/{{total}} — Envoi…",
      "saving": "Vidéo {{current}}/{{total}} — Enregistrement…",
      "uploadFailed": "Upload vidéo {{number}} échoué ({{status}})"
    },
    "permission": {
      "title": "Permission requise",
      "message": "Autorisez l'accès à votre galerie."
    }
  },
  "artsScreen": {
    "header": {
      "title": "🎨 Arts",
      "subtitle": "Concours créatifs"
    },
    "tabs": {
      "sessions": "Sessions",
      "explore": "Explorer",
      "submit": "Soumettre",
      "classement": "Classement"
    },
    "empty": {
      "noSessionJoined": "Aucune session rejointe",
      "exploreHint": "Explorez les concours disponibles",
      "noActiveRun": "Aucun run actif pour cette session",
      "noContestAvailable": "Aucun concours disponible",
      "comeBackLater": "Revenez plus tard",
      "noSubmissionOpenRun": "Aucun run ouvert aux soumissions",
      "waitAdminHint": "Attendez que l'administrateur ouvre les soumissions",
      "noResultAvailable": "Aucun résultat disponible",
      "resultsAppearHint": "Le classement apparaît quand les votes sont ouverts"
    },
    "noActiveRunBadge": "Aucun run actif",
    "back": "Retour",
    "notEnrolled": "Vous n'êtes pas encore inscrit à ce run",
    "submitWorksButton_one": "Soumettre {{count}} œuvre",
    "submitWorksButton_other": "Soumettre {{count}} œuvres",
    "completeSubmissions": "Compléter mes soumissions ({{current}}/{{max}})",
    "mySubmissions": "Mes soumissions ({{current}}/{{max}})",
    "participateFree": "Participer — Gratuit",
    "participatePaid": "Participer — {{price}} CFA",
    "worksToSubmit_one": "{{count}} œuvre à soumettre",
    "worksToSubmit_other": "{{count}} œuvres à soumettre",
    "worksRequired_one": "{{count}} œuvre requise",
    "worksRequired_other": "{{count}} œuvres requises",
    "chooseRun": "Choisir un run",
    "chooseAnotherRun": "Choisir un autre run",
    "worksProgress_one": "{{count}} œuvre",
    "worksProgress_other": "{{count}} œuvres",
    "readyToSend": "✓ Prêt à envoyer",
    "missingWorks_one": "{{count}} manquante",
    "missingWorks_other": "{{count}} manquantes",
    "ruleExact": "Ce run requiert exactement",
    "ruleAllSlots": "Tous les slots doivent être remplis avant l'envoi.",
    "sendWorks_one": "Envoyer {{count}} œuvre",
    "sendWorks_other": "Envoyer {{count}} œuvres",
    "fillAllSlots": "Remplissez tous les slots ({{ready}}/{{total}})",
    "successTitle": "✅ Soumission complète",
    "successMessage_one": "Votre œuvre a été soumise avec succès !",
    "successMessage_other": "Vos {{count}} œuvres ont été soumises avec succès !",
    "status": {
      "draft": "📝 Brouillon",
      "submissionsOpen": "🖼️ Soumissions ouvertes",
      "votingOpen": "🗳️ Votes ouverts",
      "finished": "🏆 Terminé"
    },
    "quota": "{{current}}/{{max}} soumission",
    "quota_other": "{{current}}/{{max}} soumissions",
    "slot": {
      "workLabel": "Œuvre {{number}}",
      "alreadySubmitted": "Déjà soumise",
      "required": "Requis",
      "tapToChoose": "Appuyer pour choisir",
      "tapToChange": "Appuyer pour changer",
      "formats": "JPG · PNG · WEBP",
      "descriptionPlaceholder": "Description (optionnel)…"
    },
    "uploadSteps": {
      "preparing": "Image {{current}}/{{total}} — Préparation…",
      "sending": "Image {{current}}/{{total}} — Envoi…",
      "saving": "Image {{current}}/{{total}} — Enregistrement…",
      "uploadFailed": "Upload image {{number}} échoué ({{status}})"
    },
    "permission": {
      "title": "Permission requise",
      "message": "Autorisez l'accès à votre galerie."
    }
  },
  "vraiFauxScreen": {
    "title": "Vrai ou Faux",
    "loading": "Chargement…",
    "tabs": {
      "sessions": "Sessions",
      "explore": "Explorer",
      "answers": "Réponses",
      "results": "Résultats"
    },
    "headerSub": {
      "groups": "GROUPES",
      "questions": "QUESTIONS",
      "mySessions": "MES SESSIONS",
      "explore": "EXPLORER",
      "myAnswers": "MES RÉPONSES",
      "myResults": "MES RÉSULTATS"
    },
    "mine": {
      "emptyTitle": "Aucune session rejointe",
      "emptySub": "Explorez les sessions disponibles et participez !",
      "exploreAction": "Explorer",
      "groupsLabel": "GROUPES",
      "openGroup": "Groupe ouvert à tous",
      "minScore": "Score min : {{score}} pts",
      "locked": "🔒 Requis : {{required}} pts · Vous : {{current}} pts",
      "answerButton": "Répondre",
      "insufficientScore": "Score insuffisant — vous avez {{current}} pts, requis {{required}} pts",
      "allAnswered": "Toutes les questions répondues !",
      "backToGroups": "Retour aux groupes",
      "questionCounter": "Question {{current}} / {{total}}",
      "previous": "Précédente",
      "next": "Suivante"
    },
    "explore": {
      "allJoinedTitle": "Tout rejoint !",
      "allJoinedSub": "Vous participez à toutes les sessions disponibles.",
      "free": "Gratuit",
      "paid": "💰 {{price}} CFA",
      "participate": "Participer"
    },
    "answers": {
      "participatedSessions": "SESSIONS PARTICIPÉES",
      "emptyTitle": "Aucune réponse",
      "emptySub": "Participez à une session pour voir vos réponses.",
      "groupsLabel": "GROUPES — {{session}}",
      "myAnswersLabel": "MES RÉPONSES",
      "infoBanner": "Les scores et les bonnes réponses seront révélés par l'administrateur dans l'onglet Résultats",
      "emptyRunTitle": "Aucune réponse",
      "emptyRunSub": "Vous n'avez pas encore répondu à des questions dans ce groupe.",
      "myAnswerWas": "J'ai répondu : {{answer}}"
    },
    "results": {
      "participatedSessions": "SESSIONS PARTICIPÉES",
      "emptyTitle": "Aucun résultat",
      "emptySub": "Participez à une session pour voir vos résultats.",
      "groupsLabel": "GROUPES — {{session}}",
      "pendingTitle": "Résultats pas encore révélés",
      "pendingDefaultMsg": "L'administrateur révèlera les résultats après la fermeture du run.",
      "scoreRevealed": "Score révélé :",
      "notPlayed": "Non joué",
      "pointsAwarded": "+{{points}} pts"
    },
    "true": "VRAI",
    "false": "FAUX",
    "points": "{{count}} pts",
    "errors": {
      "network": "Erreur réseau",
      "notConnected": "Non connecté",
      "sessionExpired": "Session expirée — reconnectez-vous",
      "submitError": "Erreur envoi"
    }
  }
    }
